import { Form } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type FormsState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: FormsState = {
  selected: [],
  query: '',
  names: {},
};

export const formsSlice = createSlice({
  name: 'forms',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<Form>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<Form[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((form) => form.id));
      action.payload.forEach((form) => (state.names[form.id] = form.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = formsSlice.actions;

export const getSelectedForms = (state: RootState) => state.forms.selected;

export const getSelectedNamedForms = (state: RootState) =>
  Object.entries(state.forms.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getFormsQuery = (state: RootState) => state.forms.query;

export default formsSlice.reducer;
